import React from "react";
import { FilterMultiselectOption } from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "../../lib";
import { TriStateBooleanFilter } from "../TriStateBooleanFilter/TriStateBooleanFilter";

const hasUnreadChatOption: FilterMultiselectOption = {
    value: "has_unread_chat",
    label: "Has unread chat",
    searchableLabel: "has unread chat",
};

const noUnreadChatOption: FilterMultiselectOption = {
    value: "no_unread_chat",
    label: "Does not have unread chat",
    searchableLabel: "does not have unread chat",
};

export const TaskChatFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => (
    <TriStateBooleanFilter
        value={filters.hasUnreadChat}
        onChange={(hasUnreadChat) => onChange({ hasUnreadChat })}
        trueOption={hasUnreadChatOption}
        falseOption={noUnreadChatOption}
        name="hasUnreadChat"
    />
);
